import CommonIndex from '@/views/CommonIndex.vue';
import { RouteComponent } from 'vue-router';

export default {
  path: '/content-marketing',
  meta: {
    icon: 'imarketing-content-marketing2',
    name: 'Content Marketing',
    desc: '',
    level: 1,
    index: 1,
    dir: true,
  },
  component: CommonIndex as unknown as RouteComponent,
  children: [
    {
      path: 'content-insights',
      meta: {
        icon: 'compute-monitor',
        name: 'Content Insights',
        reportId: '01010201',
      },
      component: () => import('@/views/content-marketing/content-insights/index.vue'),
    },
    {
      path: 'video-detail/:id',
      meta: {
        icon: 'compute-monitor',
        name: 'Content Insights / Video Detail',
        reportId: '01010201',
        inNotInMenu: true,
        dir: true,
        hide: true,
      },
      component: () => import('@/views/content-marketing/content-insights/video-details.vue'),
    },
    {
      path: 'content-preference',
      meta: {
        icon: 'compute-monitor',
        name: 'Content Insights / Content Preference',
        reportId: '01010201',
        inNotInMenu: true,
        dir: true,
        hide: true,
      },
      component: () => import('@/views/content-marketing/content-insights/content-preference.vue'),
    },
    {
      path: 'hotspot-radar',
      meta: {
        icon: 'compute-monitor',
        name: 'Hotspot Radar',
        reportId: '01010202',
      },
      component: () => import('@/views/content-marketing/hotspot-radar/index.vue'),
    },
  ],
};
